<template>
  <v-row justify="center">
    <template v-if="inEditMode">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="display"
            :clearable="clearable"
            :label="label"
            :placeholder="placeholder"
            :readonly="readonly"
            :rules="rules"
            class="px-3"
            v-on="on"
          />
        </template>

        <m-form-printer-full-dialog
          :title="titleComputed"
          :dialog.sync="dialog"
          :search-options="searchOptions"
          :whether-load-user-models="true"
          @pick="onPick"
        />
      </v-dialog>
    </template>
    <template v-else>
      <v-text-field
        :value="display"
        :clearable="clearable"
        :label="label"
        :placeholder="placeholder"
        :readonly="readonly"
        :rules="rules"
        class="px-3"
      />
    </template>
  </v-row>
</template>

<script>
    import MFormPrinterPicker from "@/assets/plugins/mps-form/providers/MFormPrinterPicker";
    import MFormPrinterFullDialog from "@/assets/plugins/mps-form/providers/components/dialog/MFormPrinterFullDialog";

    /**
     * 사용하는 옵션
     * {items, itemName(optional), itemValue(optional)}
     */
    export default {
        name: "MFormVuetifyPrinterPicker",
        components: {MFormPrinterFullDialog},
        extends: MFormPrinterPicker,
        data() {
            return {
                dialog: false,
            }
        },
        computed: {},
        methods: {
            onPick(pick) {
                this.dialog = false;
                this.model = pick;
            },
        },
    }
</script>